export const LOGIN_AMPLITUDE_PAGE_NAME = 'Login';
export const LOGIN_PAGE_KEY = 'login';
